import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FullScreenIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 10L20 4M20 9V4H15M10 10L4 4M9 4H4V9M10 14L4 20M4 15V20H9M14 14L20 20M15 20H20V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FullScreenIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FullScreenIcon);
